module.exports = __webpack_public_path__ + "img/img-error.a4925d40.png";